import { render, staticRenderFns } from "./FailedRowsAlert.vue?vue&type=template&id=70269204"
import script from "./FailedRowsAlert.vue?vue&type=script&lang=js"
export * from "./FailedRowsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports